export default __webpack_public_path__ + "static/27-26009c5d15dc631d38ed8279f721c831.jpg";